import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Slider,
  IconButton,
  Divider,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./FilterComponent.css";

const FilterComponent = ({ open, onClose, onApply, filters }) => {
  const [localFilters, setLocalFilters] = useState(filters);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    setLocalFilters(filters);
  }, [filters]);

  const toggleOccupancy = (value) => {
    setLocalFilters((prev) => ({
      ...prev,
      occupancy: prev.occupancy.includes(value)
        ? prev.occupancy.filter((o) => o !== value)
        : [...prev.occupancy, value],
    }));
  };

  const handleApply = () => {
    onApply(localFilters);
    onClose();
  };

  const handleClear = () => {
    setLocalFilters({
      sortOption: "",
      priceRange: [0, 10000],
      preference: "",
      occupancy: [],
      gender: "",
    });
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={isMobile} // ✅ FULLSCREEN ON MOBILE
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          borderRadius: { xs: 0, sm: "18px" },
          position: { xs: "absolute", sm: "relative" },
          bottom: { xs: 0, sm: "auto" },
          margin: 0,
          height: { xs: "100vh", sm: "auto" },
        },
      }}
    >
      {/* HEADER */}
      <DialogTitle className="filter-header">
        Filters
        <IconButton onClick={onClose} className="close-btn">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <Divider />

      <DialogContent className="filter-content">
        {/* SORT */}
        <div className="filter-section">
          <h4>Sort By</h4>
          <div className="chip-group">
            {["priceLowToHigh", "priceHighToLow"].map((item) => (
              <Button
                key={item}
                variant={
                  localFilters.sortOption === item
                    ? "contained"
                    : "outlined"
                }
                onClick={() =>
                  setLocalFilters({
                    ...localFilters,
                    sortOption: item,
                  })
                }
                className="chip-btn"
              >
                {item === "priceLowToHigh"
                  ? "Low → High"
                  : "High → Low"}
              </Button>
            ))}
          </div>
        </div>

        {/* PRICE */}
        <div className="filter-section">
          <h4>Price Range</h4>
          <Slider
            value={localFilters.priceRange}
            onChange={(e, val) =>
              setLocalFilters({
                ...localFilters,
                priceRange: val,
              })
            }
            valueLabelDisplay="auto"
            min={0}
            max={10000}
          />
        </div>

        {/* PREFERENCE */}
        <div className="filter-section">
          <h4>Preferred By</h4>
          <div className="chip-group">
            {["students", "professionals"].map((p) => (
              <Button
                key={p}
                variant={
                  localFilters.preference === p
                    ? "contained"
                    : "outlined"
                }
                onClick={() =>
                  setLocalFilters({
                    ...localFilters,
                    preference: p,
                  })
                }
                className="chip-btn"
              >
                {p}
              </Button>
            ))}
          </div>
        </div>

        {/* OCCUPANCY */}
        <div className="filter-section">
          <h4>Occupancy</h4>
          <div className="chip-group">
            {["single", "double", "triple"].map((o) => (
              <Button
                key={o}
                variant={
                  localFilters.occupancy.includes(o)
                    ? "contained"
                    : "outlined"
                }
                onClick={() => toggleOccupancy(o)}
                className="chip-btn"
              >
                {o}
              </Button>
            ))}
          </div>
        </div>

        {/* GENDER */}
        <div className="filter-section">
          <h4>Gender</h4>
          <div className="chip-group">
            {["male", "female", "other"].map((g) => (
              <Button
                key={g}
                variant={
                  localFilters.gender === g
                    ? "contained"
                    : "outlined"
                }
                onClick={() =>
                  setLocalFilters({
                    ...localFilters,
                    gender: g,
                  })
                }
                className="chip-btn"
              >
                {g}
              </Button>
            ))}
          </div>
        </div>
      </DialogContent>

      {/* FOOTER */}
      <DialogActions className="filter-footer">
        <Button onClick={handleClear} className="clear-btn">
          Clear
        </Button>
        <Button variant="contained" onClick={handleApply} className="apply-btn">
          Apply
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FilterComponent;